<template>
  <div class="container">
    <div
      v-if="userRole !== 'student'"
      class="row profile-settings justify-content-center"
    >
      <ActionPanel
        @tab-clicked="setActiveTab"
        :tabs="tabs"
        tabs-aria-label="Profile settings sections"
      />
    </div>
    <div class="row justify-content-center mt-4 mb-4">
      <div class="col-md-8 v3-data-table py-5 px-4">
        <div
          id="action-panel-tabpanel-0"
          role="tabpanel"
          aria-labelledby="action-panel-tab-0"
          v-show="state.activeTab == 'my-profile'"
        >
          <Avatar
            :user="user"
            :user-role="userRole"
            @change-avatar="setAvatar"
          />
          <div>
            <ProfileSettingForm
              :user="user"
              :avatar="state.avatar"
              :user-role="userRole"
              :active-appoinment-module-options="activeAppoinmentModuleOptions"
              :is-active-appoinment-module="isActiveAppoinmentModule"
              :is-active-kiosk-module="isActiveKioskModule"
            />
          </div>
        </div>
        <div
          id="action-panel-tabpanel-1"
          role="tabpanel"
          aria-labelledby="action-panel-tab-1"
          v-if="userRole !== 'student' && state.activeTab == 'affiliations'"
        >
          <AddLocationsForm></AddLocationsForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionPanel from "@/v3components/shared/DataTable/ActionPanel.vue"
import AddLocationsForm from "@/v3views/UserSettings/AddLocationsForm.vue"
import Avatar from "@/v3views/UserSettings/Avatar.vue"
import ProfileSettingForm from "@/v3views/UserSettings/ProfileSettingForm.vue"
import { computed, onMounted, reactive } from "vue"
import { useI18n } from "vue-i18n"

export default {
  name: "ProfileSettings",
  components: {
    ActionPanel,
    Avatar,
    ProfileSettingForm,
    AddLocationsForm
  },
  props: {
    user: {
      type: Object
    },
    userRole: {
      type: String,
      default: ""
    },
    activeAppoinmentModuleOptions: {
      type: Object
    },
    isActiveAppoinmentModule: {
      type: Boolean,
      default: false
    },
    isActiveAutoCheckInModule: {
      type: Boolean,
      default: false
    },
    isActiveKioskModule: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { t } = useI18n()

    const state = reactive({
      avatar: null,
      activeTab: null,
      isProcessing: false,
      form: {
        locations: []
      }
    })

    const tabs = computed(() => [
      {
        label: t("common.my_profile"),
        value: "my-profile"
      },
      {
        label: t("common.my_locations"),
        value: "affiliations"
      }
    ])

    onMounted(() => {
      state.activeTab = tabs.value[0].value
    })

    const setActiveTab = (tab) => {
      state.activeTab = tab.value
    }

    const setAvatar = (file) => {
      state.avatar = file ? file : state.avatar
    }

    return {
      state,
      tabs,
      setActiveTab,
      setAvatar
    }
  }
}
</script>
